import { Component, OnInit, Input } from '@angular/core';
import { takeUntil, tap } from 'rxjs/operators';
import { CompanyDTO, OrderDTO } from '../../../../../interfaces/models';
import { WalletDTO } from '../../../../../interfaces/walletDTO';
import { CompanyService } from '../../../../../providers/company/company.service';
import { DestroyableComponent } from '../../../../utils/destroyable.component';
import { TableActionService } from '../../../custom-table/services/table-action.service';

@Component({
  selector: 'app-book-order-action-view',
  templateUrl: './book-order-action-view.component.html',
  styleUrls: ['./book-order-action-view.component.scss'],
})
export class BookOrderActionViewComponent extends DestroyableComponent implements OnInit {
  @Input() data: OrderDTO;


  wallet: WalletDTO;
  company: CompanyDTO;

  constructor(
    private readonly tableActionService: TableActionService,
    private readonly companyService: CompanyService,
  ) {
    super()
  }

  ngOnInit() {
    this.companyService.getWallet().pipe(
      takeUntil(this.onDestroy),
      tap(wallet => this.wallet = wallet),
    ).subscribe()
    this.companyService.company$.pipe(
      takeUntil(this.onDestroy),
      tap(company => this.company = company),
    ).subscribe()
  }

  click() {
    this.tableActionService.bookOrder(this.data, this.wallet, this.company);
  }
}
